// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".infoField[data-v-dd1e0b18]{line-height:2em}.infoField .infoLabel[data-v-dd1e0b18]{vertical-align:top;display:inline-block;width:150px}.infoField .infoValue[data-v-dd1e0b18]{vertical-align:top;display:inline-block;font-weight:500;text-align:center}", ""]);
// Exports
module.exports = exports;
